'use client';

import React, { Key, memo, useMemo } from 'react';

import { Select, SelectItem } from '@nextui-org/react';

import { PageHeader } from '@/components/layout/page-header/page-header';

import { MscSearchInput } from '@/widgets/masterclasses/msc-search-input';
import { MASTERCLASS_SORT_OPTIONS } from '@/widgets/masterclasses/constants/sort-options';

interface Props {
  sortValue: string;
  setSortValue: (value: Key) => void;
  setSearchValue: (value: string) => void;
  searchValue: string;
  title: string;
  subtitle: string;
}
// eslint-disable-next-line react/display-name
export const MscPageHeader = memo(
  ({
    setSearchValue,
    sortValue,
    setSortValue,
    searchValue,
    title,
    subtitle,
  }: Props) => {
    const sortSelectItems = MASTERCLASS_SORT_OPTIONS;

    const rightContentMemo = useMemo(() => {
      return (
        <div className="flex w-full  justify-end gap-4">
          <MscSearchInput
            searchValue={searchValue}
            setSearchValue={setSearchValue}
          />
          <Select
            value={sortValue}
            onChange={(e) => setSortValue(e.target.value)}
            size="sm"
            radius="full"
            label="Сортировка"
            defaultSelectedKeys={['default']}
            className="w-[210px]"
          >
            {sortSelectItems.map((item) => (
              <SelectItem key={item.key}>{item.label}</SelectItem>
            ))}
          </Select>
        </div>
      );
    }, [searchValue, setSearchValue, setSortValue, sortValue]);

    return (
      <div className="hidden md:block">
        <PageHeader
          goBack={false}
          titleTag="h2"
          title={title}
          subTitle={subtitle}
          rightContent={rightContentMemo}
        />
      </div>
    );
  },
);
